import { Modal } from "react-bootstrap";
import InlineSpinner from "../loading/InlineSpinner";
import { usePartner } from "../../helpers/BrandPageAPI";

const AddCustomizeModal = ({
  show,
  onHide,
  handleAddToCart,
  textareaRef,
  product,
  isLoading,
}) => {
  const onCloseModal = () => {
    onHide();
  };
  const { partnerData } = usePartner();
  const buttonColor = partnerData?.StoreColor || "#d4af37";
  return (
    <Modal
      show={show}
      onHide={onCloseModal}
      className="product-quickview-modal-wrapper customize_modal"
      backdrop="static"
    >
      <Modal.Header closeButton>
        <Modal.Title as={"h5"}>Add Customize Instructions</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <textarea
          ref={textareaRef}
          name="instruction_textarea"
          id="instruction_textarea"
          rows="5"
        ></textarea>
      </Modal.Body>
      <Modal.Footer>
        <button className="button error_btn" onClick={onCloseModal}>
          Close
        </button>
        <button
          className="button primary_btn"
          onClick={(e) => handleAddToCart(e, product)}
          style={{ minWidth: "125px", background: buttonColor }}
        >
          {isLoading ? <InlineSpinner /> : "Add to cart"}
        </button>
      </Modal.Footer>
    </Modal>
  );
};

export default AddCustomizeModal;
